var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13 13",
    style: {
      enableBackground: "new 0 0 13 13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.1333342,7.3666668H0.8666658C0.3880195,7.3666668,0,6.9786472,0,6.500001V6.499999 c0-0.4786463,0.3880195-0.8666658,0.8666658-0.8666658h11.2666683C12.6119804,5.6333332,13,6.0213528,13,6.499999V6.500001 C13,6.9786472,12.6119804,7.3666668,12.1333342,7.3666668z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/Zoom_Out.8c14dc606bc5282bdd6953122893c539.svg";
export { ForwardRef as ReactComponent };